export enum HOTSPOT_SIMPLE_ITEM_TYPE {
  PUBLISH = 'HotspotSimpleItem',
  AUTHOR = 'HotspotSimpleAuthorItem',
}
